import React from "react";
import {
  ControlledCustomSelect,
  CustomFormLabel,
} from "../../components/formsComponents";
import { useSelector } from "react-redux";
import { selectDropdownData } from "../../redux/MasterDropdowns/MasterDropdownsSelectors";
import { SelectChangeEvent, SxProps, Theme } from "@mui/material";
import { useDispatchWrapper } from "../../hooks";
import { fetchMasterDropdownIfNeeded } from "../../redux/MasterDropdowns/MasterDropdownsActions";

export interface IMasterDropdownProps {
  dropdownCode: string;
  label?: string;
  fullWidth?: boolean;
  value: any;
  onChange: (event: SelectChangeEvent<unknown>, child: React.ReactNode) => void;
  errorMessage?: string;
  disabled?: boolean;
  placeholder?: string;
  sx?: SxProps<Theme>
}

export const MasterDropdown: React.FC<IMasterDropdownProps> = ({
  dropdownCode,
  value,
  onChange,
  disabled,
  placeholder,
  fullWidth,
  label,
  errorMessage,
  sx
}) => {
  const dropdownData = useSelector(selectDropdownData(dropdownCode));
  const dispatch = useDispatchWrapper();

  React.useEffect(() => {
    dispatch(fetchMasterDropdownIfNeeded(dropdownCode));
  }, [dropdownCode]);

  return (
    <>
      {label && <CustomFormLabel>{label}</CustomFormLabel>}
      <ControlledCustomSelect
        fullWidth={fullWidth}
        value={value}
        options={dropdownData.list}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        error={errorMessage ? true : false}
        helperText={errorMessage}
        sx={sx}
      />
    </>
  );
};
